import { useEffect, useState, useCallback } from 'react';
import { lclClient } from '../api/lclClient';
import toast from 'react-hot-toast';

export function useLclPrelevements({ date_reglement, exported = 'false' } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    if (!date_reglement) { setData([]); return; }
    setLoading(true);
    try { setData(await lclClient.listPrelevements({ date_reglement, exported })); }
    catch (e) { toast.error(`Chargement prélèvements: ${e.message}`); }
    finally { setLoading(false); }
  }, [date_reglement, exported]);

  const exportCsv = useCallback(async (invoice_ids, resolution_strategy = 'none') => {
    const t = toast.loading('Génération CSV LCL…');
    try {
      const { fileName, content_base64, batch } = await lclClient.exportPrelevements({
        date_reglement, invoice_ids, resolution_strategy,
      });
      const bytes = Uint8Array.from(atob(content_base64), (c) => c.charCodeAt(0));
      const blob = new Blob([bytes], { type: 'text/csv;charset=iso-8859-1' });
      const url = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement('a'), { href: url, download: fileName });
      a.click(); URL.revokeObjectURL(url);
      toast.success(`${batch.item_count} prélèvement(s) exporté(s)`, { id: t });
      await refetch();
    } catch (e) {
      toast.error(`Erreur: ${e.response?.data?.message || e.message}`, { id: t });
    }
  }, [date_reglement, refetch]);

  useEffect(() => { refetch(); }, [refetch]);
  return { data, loading, refetch, exportCsv };
}
